import { render } from "./CarouselDesktop.vue?vue&type=template&id=2fb38056&scoped=true"
import script from "./CarouselDesktop.vue?vue&type=script&lang=js"
export * from "./CarouselDesktop.vue?vue&type=script&lang=js"

import "./CarouselDesktop.vue?vue&type=style&index=0&id=2fb38056&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb38056"]])

export default __exports__